import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ActivityPriority } from '../models/types/act_priority';
import { ActivityRegarding } from '../models/types/act_regarding';
import { ActivitySubject } from '../models/types/act_subject';
import { ActivityStatus } from '../models/types/act_status';
import { environment } from '../../../environments/environment';

@Injectable()
export class ActivityTypeService {
    constructor(private http: HttpClient) { }
    getAllActTypes() {
        this.getRegarding();
        this.priority();
        this.getSubject();
        this.status();
        this.getItems()
        this.getCategory()
        this.getProductSetting()
        this.getStoneSetting()
        this.getSubStoneSetting()
        this.getSubItems()
    }
    getRegarding() {
        this.http.get<ActivityRegarding>(`${environment.api}activity_regarding`).subscribe(res => {
            sessionStorage.setItem('activityregarding', JSON.stringify(res['data']));
        });
    }
    getSubject() {
        this.http.get<ActivitySubject>(`${environment.api}activity_subject`).subscribe(res => {
            sessionStorage.setItem('activitysubject', JSON.stringify(res['data']));
        });
    }
    priority() {
        this.http.get<ActivityPriority>(`${environment.api}activity_priority`).subscribe(res => {
            sessionStorage.setItem('activitypriority', JSON.stringify(res['data']));
        });
    }
    status() {
        this.http.get<ActivityStatus>(`${environment.api}activity_status`).subscribe(res => {
            sessionStorage.setItem('activitystatus', JSON.stringify(res['data']));
        });
    }

    getItems() {
        this.http.get<ActivityStatus>(`${environment.api}oppty_items`).subscribe(res => {
            sessionStorage.setItem('activityitems', JSON.stringify(res['data']));

        })
    }
    getSubItems() {
        this.http.get<ActivityStatus>(`${environment.api}oppty_sub_items`).subscribe(res => {
            sessionStorage.setItem('pocsubitems', JSON.stringify(res['data']));

        })
    }
    getCategory() {
        this.http.get<ActivityStatus>(`${environment.api}oppty_poc_category`).subscribe(res => {
            sessionStorage.setItem('opptypoccategory', JSON.stringify(res['data']));
        })
    }
    getProductSetting() {
        this.http.get(`${environment.api}product_settings`).subscribe(res => {
            sessionStorage.setItem('productsettings', JSON.stringify(res['data']));
        })
    }
    getStoneSetting() {
        this.http.get(`${environment.api}stone_settings`).subscribe(res => {
            sessionStorage.setItem('stonesettings', JSON.stringify(res['data']));
        })
    }

    getSubStoneSetting() {
        this.http.get(`${environment.api}substone_settings`).subscribe(res => {
            sessionStorage.setItem('substonesettings', JSON.stringify(res['data']));
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/activity-type.service.ts